import { SIZE } from 'common/sizes';
import styled from 'styled-components';
import { COLUMN_WIDTH } from '../constants'

interface IRootProps {
    openMenu?: Boolean;
    status?: string;
}

export const Root = styled.div`
  width: 100%;
  padding: 10px 0px 10px 0px;
  margin: 0 ${SIZE.ONE}px;
`;

export const Row = styled.div`
    height: 54px;
    display: flex;
    flex-wrap: nowrap;
    border-radius: 5px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
    flex: 1;
`;

export const Column = styled.div`  
    flex-direction: column;
    padding: 15.2px 20px;
    position:relative;
    &:after{
      content: " ";
      position: absolute;
      border-left: 1px rgba(32, 64, 120, 0.2) solid;
      top: 20%;
      right: 0;
      height: 60%;
      margin-top: auto;
      margin-bottom: auto;
    }
    @media (max-width: 1500px) {
      padding: 15px 15px;
    }
    @media (max-width: 1300px) {
      padding: 15px 12.5px;
    }
`;

export const ColSpecial = styled(Column)`
    font-family: Rubik;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #272727;
    flex: ${COLUMN_WIDTH['Special']};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    @media (max-width: 1300px) {
        flex: ${COLUMN_WIDTH['Special']};
    }
`;

export const ColActivity = styled(Column)`
    font-family: Rubik;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #272727;
    flex: ${COLUMN_WIDTH['Activity']};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    @media (max-width: 1300px) {
        flex: ${COLUMN_WIDTH['Activity']};
    }
`;

export const ColListings = styled(Column)`
    text-align:center;
    position: relative;
    flex: ${COLUMN_WIDTH['Listings']};
    padding-top:12px;
    @media (max-width: 1300px) {
        height: 35px;
        flex: ${COLUMN_WIDTH['Listings']};
    }
`;

export const ColDateTime = styled(Column)`
    font-family: Rubik;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #272727;
    text-align: left;
    min-width: ${SIZE.TWENTYSIX}px;
    flex: ${COLUMN_WIDTH['Date and Time']};
    @media (max-width: 1300px) {
        flex: ${COLUMN_WIDTH['Date and Time']};
    }
`;

export const ColViews = styled(Column)`
    font-family: Rubik;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #272727;

    flex: ${COLUMN_WIDTH['Views']};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    @media (max-width: 1300px) {
        flex: ${COLUMN_WIDTH['Views']};
    }
`;

export const ColEngagement = styled.div`
    flex-direction: column;
    padding: 15.2px 20px;
    position:relative;
    &:after{
      content: " ";
      position: absolute;
      top: 15%;
      right: 0;
      height: 60%;
      margin-top: auto;
      margin-bottom: auto;
    }
    @media (max-width: 1500px) {
      padding: 15px 15px;
    }
    @media (max-width: 1300px) {
      padding: 15px 12.5px;
    }

    font-family: Rubik;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #272727;
    flex: ${COLUMN_WIDTH['Engagement']};
    text-overflow: ellipsis;
    white-space: nowrap;
    position:relative;
    @media (max-width: 1500px) {
        padding: 15.2px 15px;
    }
    @media (max-width: 1300px) {
        padding: 15px 12.5px;
        flex: ${COLUMN_WIDTH['Engagement']};
    }
`;
export const Label = styled.span`
  font-size: 15px;
  font-weight: normal;
  color: rgba(32, 64, 120, 0.5);
  display: inline-block;
  margin-right: 4%;
`;

export const Text = styled.span`
  font-size: 15px;
  font-weight: normal;
  color: #122442;
`;

export const FormatsAbsoluteContainer = styled.div`
  position: absolute;
  top: -15px;
  left: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 100;
  display: none;
  ${ColListings}:hover & {
    display: flex;
  }
`;

export const FormatsContainer = styled.div`
  margin: 1.7px 0 0;
  padding: 9px 12px 3px;
  border-radius: 2px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: #707070;
`;

export const FormatLabel = styled.div`
  padding: 0px 0px 0px 0px;
  font-family: Rubik;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;

`;
